// Popovers from the help_popover macro need initializing after their markup is in the page
export function initHelpPopovers(root = document){
    root.querySelectorAll('[data-bs-toggle="popover"]')
        .forEach(el => bootstrap.Popover.getOrCreateInstance(el));
}
